import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { SharedService } from '../../services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-scheme-statements',
  templateUrl: './scheme-statements.component.html',
  styleUrls: ['./scheme-statements.component.scss']
})
export class SchemeStatementsComponent implements OnInit {
  public schemeId: string;

  public userInfo: any;
  public showPlans = false;
  public visitCnt = 0;
  public portfolioData: any;

  constructor(private _api: ApiService,
    public _shared: SharedService,
    private _route: ActivatedRoute,
    private _router: Router) {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.userInfo = this._shared.userInfo;
  }

  ngOnInit() {
    this.schemeId = (this._route.snapshot.paramMap.get('id') === null) ? '110' : this._route.snapshot.paramMap.get('id');
    this.getPortfolio();
  }
  getPortfolio() {
    this._api.getSchemePortfolio(this.schemeId).subscribe((response) => {
      //console.log(response);
      if (response.status === 'success') {
        this.portfolioData = response.data;
      }
    });
  }
}
